import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const UPDATED = "22 de outubro de 2026";
const CONTACT = "contato@autooficina.com.br";

const PRIVACY = [
  ["1. Quem somos", [`O AutoOficina é um sistema online de gestão para oficinas mecânicas. Para qualquer dúvida sobre privacidade ou sobre seus dados, fale com a gente pelo e-mail ${CONTACT}.`]],
  ["2. Quais dados coletamos", [
    "Dados das oficinas: nome, razão social, CNPJ, endereço, telefone, logo, dados de recebimento e dados dos usuários da equipe (nome, e-mail).",
    "Dados dos clientes das oficinas: nome, CPF/CNPJ, telefone, e-mail, endereço e data de nascimento, quando informados pela oficina.",
    "Dados de veículos e serviços: placa, marca, modelo, ano, chassi, quilometragem, ordens de serviço, orçamentos, checklists, pagamentos, fotos e vídeos dos veículos.",
    "Dados técnicos de uso: registros de acesso, data e hora, endereço IP e tipo de navegador, para segurança e funcionamento do serviço.",
  ]],
  ["3. Para que usamos os dados", [
    "Prestar o serviço: abrir e acompanhar ordens de serviço, gerar orçamentos e PDFs, enviar links e avisos aos clientes, emitir notas fiscais e controlar o financeiro da oficina.",
    "Comunicação: enviar e-mails e mensagens sobre o serviço, como orçamento pronto, carro pronto e lembretes de revisão.",
    "Segurança, suporte, prevenção de fraudes e cumprimento de obrigações legais.",
    "A oficina é a controladora dos dados dos seus clientes; o AutoOficina atua como operador, tratando esses dados apenas conforme as instruções da oficina e esta política (LGPD, Lei nº 13.709/2018).",
  ]],
  ["4. Compartilhamento", [
    "Não vendemos dados pessoais. Compartilhamos apenas o necessário com provedores que nos ajudam a operar o serviço, como: envio de e-mails (Resend), emissão de nota fiscal, processamento de pagamentos, envio de WhatsApp, hospedagem e armazenamento de arquivos.",
    "Também podemos compartilhar dados quando exigido por lei ou por ordem de autoridade competente.",
  ]],
  ["5. Uso do Google Drive", [
    "O AutoOficina pode se conectar ao Google Drive APENAS pela conta do super administrador do sistema, com a única finalidade de guardar cópias de segurança (backups) do banco de dados em uma pasta chamada \"AutoOficina Backups\".",
    "Usamos somente o escopo drive.file, que dá acesso apenas aos arquivos criados pelo próprio app. O AutoOficina não lê, não lista e não altera nenhum outro arquivo do Drive.",
    "O uso e a transferência de informações recebidas das APIs do Google seguem a Política de Dados do Usuário dos Serviços de API do Google (Google API Services User Data Policy), incluindo os requisitos de Uso Limitado (Limited Use). Esses dados não são usados para publicidade, não são vendidos e não são compartilhados com terceiros.",
    "O acesso pode ser desconectado a qualquer momento na tela Backups ou nas configurações da conta Google.",
  ]],
  ["6. Segurança", [
    "Usamos conexão criptografada (HTTPS), senhas protegidas por hash, chaves e tokens de integração guardados criptografados, separação dos dados por oficina e controle de acesso por perfil (dono, equipe, cliente).",
  ]],
  ["7. Retenção", [
    "Mantemos os dados enquanto a conta da oficina estiver ativa. Após o cancelamento, os dados podem ser mantidos pelo prazo necessário para cumprir obrigações legais e fiscais, e depois são excluídos ou anonimizados.",
    "As cópias de segurança são mantidas por até 30 dias.",
  ]],
  ["8. Seus direitos", [
    "Pela LGPD, você pode pedir: confirmação de que tratamos seus dados, acesso, correção, anonimização ou exclusão, portabilidade, informação sobre compartilhamento e revogação do consentimento.",
    `Clientes de oficinas podem pedir diretamente à oficina ou pelo e-mail ${CONTACT}. Respondemos no menor prazo possível.`,
  ]],
  ["9. Alterações", ["Esta política pode ser atualizada. A data da última atualização fica sempre no topo desta página."]],
];

const TERMS = [
  ["1. O serviço", [
    "O AutoOficina é um sistema online para gestão de oficinas mecânicas: ordens de serviço, orçamentos, clientes, estoque, financeiro e outras funções, conforme o plano contratado.",
    "Ao criar uma conta ou usar o sistema, você concorda com estes Termos e com a Política de Privacidade.",
  ]],
  ["2. Conta e uso", [
    "A oficina é responsável pelos dados que cadastra, pela veracidade das informações e por manter as senhas da sua equipe em sigilo.",
    "É proibido usar o serviço para atividades ilegais, enviar mensagens indesejadas (spam) ou tentar acessar dados de outras oficinas.",
  ]],
  ["3. Teste grátis e mensalidade", [
    "Novas oficinas têm 14 dias de teste grátis. Após o teste, o uso continua mediante pagamento da mensalidade do plano escolhido e dos adicionais contratados.",
    "Valores e o que cada plano inclui aparecem em Configurações › Meu plano. Mudanças de preço serão avisadas com antecedência.",
    "Em caso de atraso no pagamento, o acesso pode ser suspenso até a regularização, sem apagar os dados.",
  ]],
  ["4. Responsabilidades", [
    "O AutoOficina se compromete a manter o serviço funcionando, com cópias de segurança diárias e suporte pelo e-mail de contato.",
    "A oficina é responsável pelos serviços prestados aos seus clientes, pelos preços, pelas informações fiscais e pelo cumprimento da LGPD em relação aos dados dos seus clientes.",
  ]],
  ["5. Cancelamento", [
    `A oficina pode cancelar a qualquer momento, sem multa, pelo e-mail ${CONTACT} ou pelo suporte do app. O acesso segue até o fim do período já pago.`,
    "A oficina pode pedir uma exportação dos seus dados antes do cancelamento.",
  ]],
  ["6. Limitação de responsabilidade", [
    "O serviço é fornecido como está. Não nos responsabilizamos por perdas indiretas, lucros cessantes ou falhas causadas por terceiros (internet, provedores de nota fiscal, pagamento ou WhatsApp).",
    "Quando houver responsabilidade, ela fica limitada ao valor pago pela oficina nos últimos 12 meses.",
  ]],
  ["7. Foro", ["Estes Termos seguem as leis do Brasil. Fica eleito o foro da comarca de São Paulo/SP para resolver qualquer questão, salvo disposição legal em contrário."]],
  ["8. Alterações", ["Estes Termos podem ser atualizados. Avisaremos as oficinas sobre mudanças importantes."]],
];

function LegalPage({ title, sections, testid }) {
  return (
    <div data-testid={testid} className="min-h-screen bg-[#0a0d0b] text-zinc-300">
      <div className="mx-auto max-w-3xl px-5 py-10 md:py-16">
        <Link to="/login" data-testid="legal-back" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-zinc-100 transition-colors">
          <ArrowLeft className="h-4 w-4" /> Voltar
        </Link>
        <img src="/brand/autotrack-logo.png" alt="AutoOficina" className="h-12 mt-8" />
        <h1 className="font-display text-4xl sm:text-5xl font-black uppercase text-zinc-100 mt-6">{title}</h1>
        <p className="text-xs text-zinc-500 mt-2" data-testid="legal-updated">Última atualização: {UPDATED}</p>
        <div className="mt-10 space-y-8">
          {sections.map(([h, ps]) => (
            <section key={h}>
              <h2 className="font-display text-base md:text-lg font-bold uppercase text-green-400">{h}</h2>
              <div className="mt-2 space-y-2 text-sm md:text-base leading-relaxed">
                {ps.map((p) => <p key={p}>{p}</p>)}
              </div>
            </section>
          ))}
        </div>
        <p className="mt-12 text-xs text-zinc-500">Contato: <a href={`mailto:${CONTACT}`} className="underline">{CONTACT}</a></p>
      </div>
    </div>
  );
}

export const PrivacyPage = () => <LegalPage title="Política de Privacidade" sections={PRIVACY} testid="privacy-page" />;
export const TermsPage = () => <LegalPage title="Termos de Serviço" sections={TERMS} testid="terms-page" />;
